import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import TasksScreen from './TasksScreen';
import ItemsViewer from '../components/Common/ItemsViewer/';

const DirectoryScreen = () => {
  const { slug } = useParams();
  const rootUrl = 'api';
  const section = 'directories';

  const { userInfo, permissions } = useSelector((state) => state.auth);
  const perm = {
    canRead: userInfo?.isAdmin || !!permissions?.directories?.[slug]?.read,
    canRun: userInfo?.isAdmin || !!permissions?.directories?.[slug]?.run,
    canCreate: userInfo?.isAdmin || !!permissions?.directories?.[slug]?.create,
    canDelete: userInfo?.isAdmin || !!permissions?.directories?.[slug]?.delete,
  };

  const legacyView = (
    <ItemsViewer
      rootUrl={rootUrl}
      section={section}
      slug={slug}
      permissions={perm}
    />
  );

  // В старых режимах у справочника собственные permissions и адреса переходов.
  // Общий task-экран выбирает новую форму только по серверному enforce.
  if (slug === 'tasks') {
    return <TasksScreen legacyView={legacyView} />;
  }

  return legacyView;
};

export default DirectoryScreen;
